export const MAX_API_TOKENS_PER_USER = 10;
export const MAX_API_TOKEN_DESCRIPTION_LENGTH = 100;
export const MAX_TOKEN_TTL_DAYS = 365;
export const DEFAULT_TOKEN_TTL_DAYS = 7;

export const TOKEN_LIFETIME_OPTIONS = [7, 30, 90, 180, 365] as const;

export type ApiToken = {
  id: number;
  token: string;
  expires_at: string;
  description: string;
  created_at: string;
  updated_at: string;
  is_expired: boolean;
};

export type CreateApiTokenRequest = {
  description: string;
  expires_in_days?: number;
};

export type UpdateApiTokenRequest = {
  description: string;
};
